import { render, staticRenderFns } from "./GoalsProgress.vue?vue&type=template&id=30d6e9b0&scoped=true&"
import script from "./GoalsProgress.vue?vue&type=script&lang=js&"
export * from "./GoalsProgress.vue?vue&type=script&lang=js&"
import style0 from "./GoalsProgress.vue?vue&type=style&index=0&id=30d6e9b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d6e9b0",
  null
  
)

export default component.exports